export default "__VITE_ASSET__BK7nSVT5__"